module.exports = __webpack_public_path__ + "static/media/pink_animal_mammals.fb9ad6ee.png";